import splitzSetup from './splitz-setup.js';
import lj from './lumberjack';
import { isMobile } from './modules/util.js';
import { getLjEventProps } from '../getLjEventProps';

let ljproperties = getLjEventProps();

lj.setupLJ();

const X_PAYOUTS_SUPPORTING_TEXT = {
  stage_exp_id: 'IhzMADo5V7rwh5',
  prod_exp_id: 'Ihz83M5mpAx5CG',
  default_variant: 'x_payouts_supporting_text_disabled',
  experiment_variable: 'x_payouts_supporting_text_enabled'
};

function evaluateExpVariables(resp, EXPERIMENT_DATA) {
  if (resp === EXPERIMENT_DATA['default_variant'] || !resp.variables) {
    return false;
  }
  let respValue = false;
  resp.variables.forEach(element => {
    if (element.key == EXPERIMENT_DATA['experiment_variable'])
      respValue = element.value === 'true';
  });
  return respValue;
}

function evaluatePayoutsSupportingTextExp(splitzData) {
  const supportingText = $('.supporting-text');
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? X_PAYOUTS_SUPPORTING_TEXT['prod_exp_id']
        : X_PAYOUTS_SUPPORTING_TEXT['stage_exp_id'],
      X_PAYOUTS_SUPPORTING_TEXT['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, X_PAYOUTS_SUPPORTING_TEXT)) {
        supportingText.removeClass('hide');
        supportingText.attr('data-x-payouts-experiment-variant', 'enabled');
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            page: 'payouts',
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        supportingText.addClass('hide');
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            page: 'payouts',
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

(function() {
  let splitzData = splitzSetup.init();
  evaluatePayoutsSupportingTextExp(splitzData);
})();
